<div class="maintenance-timer-dashboard">
  <wr-maintenance-timer-dashboard-filter [initialParams]="filterParams()"
                                         (searchRequested)="search($event)"
                                         (addMaintenanceTimer)="addMaintenanceTimer()"></wr-maintenance-timer-dashboard-filter>
  <wr-maintenance-timer-dashboard-list [filter]="filter()"
                                       (addMaintenanceTimer)="addMaintenanceTimer($event.buildingId)"></wr-maintenance-timer-dashboard-list>
</div>
